import { Provider } from 'jotai'
import { jotaiStore } from '../../lib/store'
import { Component } from 'react'

export const JotaiStoreProvider: React.FC<{ children?: Component }> = ({
  children
}) => {
  return <Provider store={jotaiStore}>{children as React.ReactNode}</Provider>
}
